package org.example.project.service

import androidx.compose.runtime.mutableStateMapOf
import org.example.project.utils.All

object NotepadService {

    private val notesByArt    = mutableStateMapOf<String, List<All>>()
    private val openByArt     = mutableStateMapOf<String, List<String>>()

    fun getNotes(art: String): List<All>    = notesByArt[art]  ?: emptyList()
    fun getOpenIds(art: String): List<String> = openByArt[art] ?: emptyList()

    fun setNotes(art: String, notes: List<All>) { notesByArt[art] = notes }

    fun openNote(art: String, id: String) {
        val current = openByArt[art] ?: emptyList()
        if (id !in current) openByArt[art] = current + id
    }

    fun closeNote(art: String, id: String) {
        openByArt[art] = (openByArt[art] ?: emptyList()).filter { it != id }
    }

    fun updateNote(art: String, updated: All) {
        notesByArt[art] = (notesByArt[art] ?: emptyList()).map {
            if (it.id == updated.id) updated else it
        }
    }

    fun removeNote(art: String, id: String) {
        notesByArt[art] = (notesByArt[art] ?: emptyList()).filter { it.id != id }
        closeNote(art, id)
    }
}